export const entityCollectionGuard = 'GET /entities';
